import { create } from 'zustand';
import { createSelectors } from '../../../utils/store';

/**
 * Bridge between the navbar's "replay the tutorial" menu item and the
 * layout-mounted CoachOnboardingTour orchestrator. A replay request restarts
 * the tour regardless of the completed/seen flags; the orchestrator clears it
 * once the run starts.
 */
type State = {
  replayRequested: boolean;
  requestReplay: () => void;
  clearReplayRequest: () => void;
};

const store = create<State>((set) => ({
  replayRequested: false,
  requestReplay: () => set({ replayRequested: true }),
  clearReplayRequest: () => set({ replayRequested: false }),
}));

export const useCoachTourStore = createSelectors(store);
